<input matInput [formControl]="$any(field)?.formControl" (keyup)="updateTyping($event)"  [matAutocomplete]="auto" />
<mat-autocomplete #auto="matAutocomplete" (optionSelected)="onOptionSelected($event)">
  <mat-option *ngFor="let historyItem of history" [value]="historyItem">
    {{ historyItem }}
  </mat-option>
</mat-autocomplete>